import React from 'react';
import { formatDistanceToNow } from 'date-fns';

const STATUS_LABELS = {
  succeeded: 'Succeeded',
  running: 'Running',
  failed: 'Failed',
  queued: 'Queued'
};

function TaskHistoryTable({ tasks = [], isLoading = false }) {
  if (isLoading) {
    return (
      <div className="table-loading" role="status">
        <span className="skeleton-row" />
        <span className="skeleton-row" />
        <span className="skeleton-row" />
      </div>
    );
  }

  if (!tasks.length) {
    return <p className="tab-empty">No tasks recorded yet.</p>;
  }

  return (
    <table className="data-table">
      <thead>
        <tr>
          <th>Task</th>
          <th>Status</th>
          <th>Started</th>
          <th>Duration</th>
          <th>Tokens</th>
        </tr>
      </thead>
      <tbody>
        {tasks.map((task) => (
          <tr key={task.id}>
            <td>
              <strong>{task.title}</strong>
              <span className="table-sub">{task.id}</span>
            </td>
            <td>
              <span className={`status-pill status-${task.status}`}>
                {STATUS_LABELS[task.status] || task.status}
              </span>
            </td>
            <td>{formatDistanceToNow(new Date(task.startedAt), { addSuffix: true })}</td>
            <td>{task.durationMin}m</td>
            <td>{task.tokens.toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default TaskHistoryTable;
